/**
 * The annual reports, newest at the top left, oldest at the bottom.
 *
 * One page of covers that scrolls, and no controls at all: there is one report a year and
 * there always will be, so a shelf of a dozen covers is the whole collection.
 *
 * The shelf itself, and the two windows a report can open in, are PdfShelf — shared with
 * the printed newsletters, because which window a reader gets is the same decision the
 * Worker makes about which edition to serve, and it should be made once. What is left
 * here is the words: a report is addressed by its year.
 */
import { PageHeader } from '../App'
import { useApi } from '../lib/api'
import PdfShelf from '../components/PdfShelf'

export default function AnnualReports() {
  const query = useApi('annual-reports', 'annual-reports')

  return (
    <PageHeader
      title="Annual Reports"
      sub="The annual reports the organization has published, one for each year"
    >
      <PdfShelf
        query={query}
        base="annual-reports"
        noun="report"
        icon="book"
        describe={(r) => ({ heading: r.year, sub: r.title })}
        nameOf={(r) => `the ${r.year} annual report`}
        windowTitle={(r) => `${r.year} — ${r.title}`}
        emptyTitle="No annual reports yet"
        emptyBody={
          <>
            Reports are added on Imports → Import Annual Reports, which reads the file and
            shelves it.
          </>
        }
      />
    </PageHeader>
  )
}
